module.exports = __webpack_public_path__ + "images/FUSA_icons/045-online-shop-5.46f4e656c1f3b119be95a03fddb3941f.svg";